export enum Actions {
  SET_LOGIN = 'SET_LOGIN',
  SET_CHAT = 'SET_CHAT',
  SET_UI = 'SET_UI',
  SET_USER = 'SET_USER',
  SET_SETTINGS = 'SET_SETTINGS',
  SET_DESIGNER = 'SET_DESIGNER',
  SET_COLOR = 'SET_COLOR',
  SET_CONVERSATION_ASSIGNEE_LIST = 'SET_CONVERSATION_ASSIGNEE_LIST',
  SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES',
  SET_SELECTED_CONVERSATION = 'SET_SELECTED_CONVERSATION',
  SET_COMPANY_SETTINGS = 'SET_COMPANY_SETTINGS',
  ADD_COMPANY_MEMBER = 'ADD_COMPANY_MEMBER',
  UPDATE_COMPANY_PACKAGES_SUCCESS = 'UPDATE_COMPANY_PACKAGES_SUCCESS',
  UPDATE_COMPANY_PLATFORM_FEATURES_SUCCESS = 'UPDATE_COMPANY_PLATFORM_FEATURES_SUCCESS',
  UPDATE_COMPANY_PLATFORM_FEATURES_METADATA_SUCCESS = 'UPDATE_COMPANY_PLATFORM_FEATURES_METADATA_SUCCESS',
  TOGGLE_PERMISSION_FOR_ROLE = 'TOGGLE_PERMISSION_FOR_ROLE',
  SET_ROLES = 'SET_ROLES',
  UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER',
  UPDATE_BLOCKS = 'UPDATE_BLOCKS',
  DELETE_BLOCKS = 'DELETE_BLOCKS',
  BLOCK_UPDATES_CLEAR = 'BLOCK_UPDATES_CLEAR',
  SET_ASSIGNABLE_ROLES = 'SET_ASSIGNABLE_ROLES',
  SET_LINK_STATISTICS = 'SET_LINK_STATISTICS',
  SET_EXPORTS = 'SET_EXPORTS',
  SET_EXPORT_FILE = 'SET_EXPORT_FILE',
  REMOVE_EXPORT = 'REMOVE_EXPORT',
  SET_GDPR_USERS = 'SET_GDPR_USERS',
  REMOVE_GDPR_USER = 'REMOVE_GDPR_USER',
  TOGGLE_SELECTED_LANGUAGE = 'TOGGLE_SELECTED_LANGUAGE',
  SET_LANGUAGES = 'SET_LANGUAGES',
  SET_EXPORT_CONFIG_STATUS = 'SET_EXPORT_CONFIG_STATUS',
  REMOVE_EXPORT_CONFIG = 'REMOVE_EXPORT_CONFIG',
  ADD_EXPORT_CONFIG = 'ADD_EXPORT_CONFIG',
  EDIT_EXPORT_CONFIG = 'EDIT_EXPORT_CONFIG',
  SET_SELECTED_EXPORT_CONFIG = 'SET_SELECTED_EXPORT_CONFIG',
  SET_GDPR_USER = 'SET_GDPR_USER',
  SET_ACTIVITY_LOGS = 'SET_ACTIVITY_LOGS',
  ADD_CHAT_NOTIFICATIONS = 'ADD_CHAT_NOTIFICATIONS',
  CLEAR_CHAT_NOTIFICATIONS = 'CLEAR_CHAT_NOTIFICATIONS',
  SET_DEBUG_CONFIG = 'SET_DEBUG_CONFIG',
  SET_VALIDATION_CONFIG = 'SET_VALIDATION_CONFIG',
  SET_AVAILABILITIES = 'SET_AVAILABILITIES',
  SET_SELECTED_DATE = 'SET_SELECTED_DATE',
  SET_USER_DATA_MAPPING = 'SET_USER_DATA_MAPPING',
  SET_CALENDAR_FILTER = 'SET_CALENDAR_FILTER',
  SET_CALENDAR_VIEW = 'SET_CALENDAR_VIEW',
  SET_MFA_FOR_COMPANY = 'SET_MFA_FOR_COMPANY',
  SET_TIMEZONE = 'SET_TIMEZONE',
  SET_STREAMING_RESPONSE_CONFIG = 'SET_STREAMING_RESPONSE_CONFIG',
  SET_RESTART_POLICY = 'SET_RESTART_POLICY',
  SET_WEBCLIENT = 'SET_WEBCLIENT',
  SET_USER_PROFILE_FIELDS = 'SET_USER_PROFILE_FIELDS',
  SET_CHAT_PLUGIN = 'SET_CHAT_PLUGIN',
  SET_CONVERSATION_DATE = 'SET_CONVERSATION_DATE',
  SET_CREATED_NEW_DESIGNER_SUBFLOW = 'SET_CREATED_NEW_DESIGNER_SUBFLOW',
  SET_DELETED_DESIGNER_SUBFLOW = 'SET_DELETED_DESIGNER_SUBFLOW',
}
